import { useMemo } from 'react';
import { FillLayer, Layer, LineLayer } from 'react-map-gl';

type Props = {
  source: string;
};
export const OutlinedBlocksLayer = ({ source = 'no-source' }: Props) => {
  const outlineLayerStyle = useMemo<LineLayer>(
    () => ({
      id: `block-boundary-outline-${source}`,
      type: 'line',
      paint: {
        'line-color': '#FFFFFF',
        'line-opacity': 1,
        'line-width': 3,
      },
      source: source,
    }),
    [source]
  );

  const fillLayerStyle = useMemo<FillLayer>(
    () => ({
      id: `block-boundary-fill-${source}`,
      type: 'fill',
      paint: {
        'fill-color': '#FFFFFF',
        'fill-opacity': 0.4,
      },
      source: source,
    }),
    [source]
  );

  return (
    <>
      <Layer key={outlineLayerStyle.id} {...outlineLayerStyle} />
      <Layer key={fillLayerStyle.id} {...fillLayerStyle} />
    </>
  );
};
